import type { LineChartResetController } from './types';

export const createLineChartResetController = ({
  enabled,
  onReset,
  resetZoom,
}: {
  enabled: boolean;
  onReset?: () => void;
  resetZoom: () => void;
}): LineChartResetController => {
  return {
    enabled,
    reset: () => {
      resetZoom();
      onReset?.();
    },
  };
};
